import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.Feedback>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'feedback',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.Feedback[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.Feedback>) {
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<Model.Feedback>) {
      adapter.removeOne(state, action.payload.id);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.feedback,
);

export const selectFeedbackByWeek = createSelector(
  selector.selectAll,
  (state: RootState, week_id: string) => week_id,
  (feedbacks, week_id) => {
    return feedbacks.find((f) => f.week_topic_id === week_id);
  },
);

export { reducer };
export default actions;
